import { SVGProps, Ref, forwardRef } from 'react';

export const CheckOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m4.493 7.89 5.264-5.265.743.742-6.007 6.008L1.5 6.382l.742-.742z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckOutlinedSize12Glyph.displayName = 'CheckOutlinedSize12Glyph';
